export default __webpack_public_path__ + "static/media/GlowCube.6bb6afe9.png";